export interface LoginCredentials {
  email: string;
  password: string;
}

export interface CreateAccountCredentials {
  email: string;
  password: string;
}

export enum UserRole {
  creator = "creator",
  admin = "admin",
  reviewer = "reviewer",
}

export interface UserMetadata {
  role: UserRole
  userId: string
  user_id: string
}

export interface KyzzenUser {
  id: string
  username: string
  description: string
  email: string
  email_verified: boolean
  google_image_url: string
  google_linked: boolean
  twitter_username: string
  twitter_image_url: string
  twitter_verified: boolean
  twitter_verified_ohme: boolean
  telegram_username: string
  twitter_linked: boolean
  telegram_image_url: string
  telegram_verified: boolean
  telegram_linked: boolean
  discord_username: string
  discord_id: string
  discord_linked: boolean
  telegram_id: string
  discord_image_url: string
  discord_verified: boolean
  youtube_username: string
  youtube_image_url: string
  youtube_verified: boolean
  instagram_username: string
  instagram_image_url: string
  instagram_verified: boolean
  referral_code: string
  referred_by: string
  referred_by_id: string
  referrer_count: number
  referrers: number | null
  thumbnail_url: string
  banner_url: string
  wallets: string[] | null
  points: number
  registered_whitelist: boolean
  leaderboard_position: number
  subscribed_for_update: boolean
  subscription_update_time: string
  updated_at: string
  last_login: string
}
